// Components
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";
import { type TFunction, useTranslation } from "src/design-system/core/TranslationContext";

interface UpdateChannelValidationDialogProps {
    isOpen: boolean;
    onCancel: () => void;
    onSave: () => void;
    t: TFunction;
    text?: string;
}

export const UpdateChannelValidationDialog = ({
    isOpen,
    onCancel,
    onSave,
    t,
    text = "channel-update-dialog-when-smart-sub-title",
}: UpdateChannelValidationDialogProps): JSX.Element => {
    const { translateCommon } = useTranslation();
    return (
        <Dialog
            open={isOpen}
            maxWidth="lg"
            onClose={onCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="ranking-compare-method-key-dialog-title">
                {t("channel-update-dialog-when-smart-title")}
            </DialogTitle>
            <DialogContent>
                <Box marginBottom={1}>
                    <Typography>{t(text)}</Typography>
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel} color="primary">
                    {translateCommon(`actions.cancel`)}
                </Button>
                <Button color="primary" onClick={onSave}>
                    {translateCommon(`actions.confirm`)}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
